import styled from '@emotion/styled';
import React, { useCallback, useState } from 'react';

import { TextButton, Text } from '../../atoms';
import { TextField } from '../../molecules';
import Modal from '../Modal';
import theme from '../../../styles/theme';
import useForm from '../../../hooks/useForm';
import { userAPI } from '../../../service/api';

const InputForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xs};
  margin-top: ${theme.spacing.xl};
`;

const ChangePassword = () => {
  const [modalVisible, setModalVisible] = useState(false);

  const openModal = () => {
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
  };

  const handlePassword = useCallback(async (data) => {
    try {
      await userAPI.updatePassword(data);
      return true;
    } catch ({ response }) {
      const { status, data } = response;
      if (status === 400) {
        console.log(data);
      }

      return false;
    }
  }, []);

  const { values, errors, isLoading, handleChange, handleSubmit } = useForm({
    initialValue: {
      password: '',
      checkPassword: '',
    },
    onSubmit: async (values) => {
      const changePassword = await handlePassword({
        password: values.password,
        checkPassword: values.checkPassword,
      });

      if (changePassword) {
        openModal();
      }
    },
    validate: ({ password, checkPassword }) => {
      const errors = {};

      if (!password) {
        errors.password = '비밀번호를 입력해주세요.';
      } else if (!/^[A-Za-z0-9+]{8,12}$/.test(password)) {
        errors.password = '비밀번호 형식을 확인해주세요.';
      }
      if (!checkPassword) {
        errors.checkPassword = '비밀번호를 한 번 더 입력해주세요.';
      }
      if (password !== checkPassword) {
        errors.checkPassword = '입력한 비밀번호와 달라요.';
      }

      return errors;
    },
  });
  return (
    <InputForm onSubmit={handleSubmit}>
      <TextField
        name="password"
        type="password"
        isFullWidth
        label="비밀번호 변경"
        placeholder="변경할 비밀번호를 입력해주세요. (8 ~ 12 자리의 영문 + 숫자 조합)"
        iconName="lock"
        value={values.password}
        onChange={handleChange}
        error={errors.password}
      />
      {errors.password ? (
        <Text
          size="xs"
          color={theme.colors.error}
          style={{ textAlign: 'right' }}
        >
          {errors.password}
        </Text>
      ) : null}
      <TextField
        name="checkPassword"
        type="password"
        isFullWidth
        placeholder="비밀번호를 다시 입력해주세요."
        iconName="lock"
        onChange={handleChange}
        value={values.checkPassword}
        error={errors.checkPassword}
      />
      {errors.checkPassword ? (
        <Text
          size="xs"
          color={theme.colors.error}
          style={{ textAlign: 'right' }}
        >
          {errors.checkPassword}
        </Text>
      ) : null}
      <TextButton
        type="submit"
        disabled={isLoading}
        style={{ marginLeft: 'auto' }}
      >
        변경
      </TextButton>
      <Modal visible={modalVisible} onClose={closeModal}>
        비밀번호가 성공적으로 변경되었어요.
      </Modal>
    </InputForm>
  );
};

export default ChangePassword;
